import {
  getCreditData as publicGetCreditData,
  checkSufficientCredits as publicCheckSufficientCredits,
} from './multilingual-machine-v1-credit-data-translation-credits.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getCreditData: MaybeContext<
  BuildRESTFunction<typeof publicGetCreditData> & typeof publicGetCreditData
> = /*#__PURE__*/ createRESTModule(publicGetCreditData);
export const checkSufficientCredits: MaybeContext<
  BuildRESTFunction<typeof publicCheckSufficientCredits> &
    typeof publicCheckSufficientCredits
> = /*#__PURE__*/ createRESTModule(publicCheckSufficientCredits);

export {
  Quota,
  State,
  SiteCreatedContext,
  Namespace,
  DeleteStatus,
} from './multilingual-machine-v1-credit-data-translation-credits.universal.js';
export {
  CreditData,
  CreditDataTypeOneOf,
  LimitedQuota,
  GetCreditDataRequest,
  GetCreditDataResponse,
  CheckSufficientCreditsRequest,
  CheckSufficientCreditsResponse,
  ReportCreditUsageRequest,
  ReportCreditUsageResponse,
  UpdateCreditRequest,
  UpdateCreditResponse,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Asset,
  SiteCreated,
  SiteTransferred,
  SiteDeleted,
  DeleteContext,
  SiteUndeleted,
  SitePublished,
  SiteUnpublished,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  ServiceProvisioned,
  ServiceRemoved,
  SiteRenamed,
  SiteHardDeleted,
  NamespaceChanged,
  StudioAssigned,
  StudioUnassigned,
  SiteUrlChanged,
  SitePurgedExternally,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  WixelAssigned,
  WixelUnassigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  UserDomainMediaEnabled,
  UserDomainMediaDisabled,
  EditorlessAssigned,
  EditorlessUnassigned,
  Empty,
} from './multilingual-machine-v1-credit-data-translation-credits.universal.js';
export {
  QuotaWithLiterals,
  StateWithLiterals,
  SiteCreatedContextWithLiterals,
  NamespaceWithLiterals,
  DeleteStatusWithLiterals,
  CheckSufficientCreditsApplicationErrors,
} from './multilingual-machine-v1-credit-data-translation-credits.universal.js';
